import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_planrenovac.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	recuperar(p_email, p_usuario, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_planrenovac.recuperar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza
				})
		})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gestRenovac.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},

}